export default __webpack_public_path__ + "static/media/Toy.13b6d691.svg";